import { isNil } from 'lodash';
import React from 'react';
import { ImageStyle, StyleProp } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { MBText } from '@shared/components/text';
import { Colors, SharedStyles } from '@shared/styles';
import { User } from '@shared/types/user';
import { MBImage } from '../MBImage';
import { Styles } from '../styles';

export interface MBUserImageProps {
  user?: User;
  size?: 'large' | 'normal' | 'small' | 'tiny';
  style?: StyleProp<ImageStyle>;
}

function toInitials(name: string): string {
  // 1. Get initials
  // https://stackoverflow.com/a/8279881/9117995
  const match = name.match(/\b(\w)/g);
  // Note: this will return null if the name is empty.
  if (!match) {
    return '';
  }
  // 2. Join first 3 initials into a string
  return match.join('').slice(0, 2).toUpperCase();
}

export function MBUserImage({ user, style, size = 'normal' }: MBUserImageProps) {
  if (!user) {
    return (
      <MBView center style={[style || SharedStyles.fill, { backgroundColor: Colors.v2.gray10 }]} />
    );
  }

  if (!user.imageUrl || user.imageUrl.includes('imgur.com')) {
    const backgroundColor = Colors.v2.avatar.user[user.id % Colors.v2.avatar.user.length];
    return (
      <MBView center style={[style || SharedStyles.fill, { backgroundColor }]}>
        <MBText
          bold
          color={Colors.v2.purple}
          style={[
            size === 'tiny' && Styles.userPlaceholderTextTiny,
            size === 'small' && Styles.userPlaceholderTextSmall,
            size === 'large' && Styles.userPlaceholderTextLarge,
          ]}
        >
          {toInitials(user.fullName)}
        </MBText>
      </MBView>
    );
  }
  if (!isNil(user.imageUrl)) {
    return <MBImage style={style || SharedStyles.fill} source={{ uri: user.imageUrl }} />;
  }
  return null;
}
